import { useState } from 'react';
import { useMediaQuery } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import Confetti from 'react-confetti';

import {
  StyledModal,
  SubtitleText,
  Wrapper,
  Header,
  StyledBirthdayTitle,
  StyledAnimatedGiftBox,
} from './BirthdayModal.styles';

interface BirthdayModalProps {
  isOpen: boolean;
  onClose: () => void;
  onNext: () => void;
}

const BirthdayModal = ({ isOpen, onClose, onNext }: BirthdayModalProps) => {
  const [shouldAnimate, setShouldAnimate] = useState(false);

  const useFullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const confettiSettings = { width: window.innerWidth, run: shouldAnimate };

  const subtitleText = shouldAnimate
    ? `Let's see what's inside...`
    : `Go on! Tap the present to open it`;

  const handleOnClick = () => setShouldAnimate(true);

  return (
    <StyledModal
      open={isOpen}
      onClose={onClose}
      closeType="close"
      fullScreen={useFullScreen}
      aria-label="Birthday Modal"
    >
      <Wrapper>
        <Header>
          <StyledBirthdayTitle />
          <StyledAnimatedGiftBox
            aria-label="Claim your birthday gift"
            onClick={handleOnClick}
            shouldAnimate={shouldAnimate}
            onAnimationEnd={onNext}
          />
          <SubtitleText variant="h2">{subtitleText}</SubtitleText>
        </Header>
      </Wrapper>

      <Confetti {...confettiSettings} />
    </StyledModal>
  );
};

export default BirthdayModal;
